import { useAuth } from '@/stores';

export function roleGuard(requiredRoles: string[]) {
  const userStore = useAuth();
  return userStore.role
    ? requiredRoles.includes(userStore.role)
    : false;
}
